import React from 'react'
import Tooltip from '@material-ui/core/Tooltip'

import { Tag } from '../../Tags/types'

type TagsIndicatorProps = {
  tags?: Tag[] | null
}

const TagsIndicator: React.FC<TagsIndicatorProps> = ({ tags }) => {
  if (!tags || !tags.length) return <>No</>

  return (
    <Tooltip
      title={
        <div>
          {tags.map(tag => (
            <div key={tag.id}>{tag.title}</div>
          ))}
        </div>
      }
      placement="bottom-start"
    >
      <span style={{ cursor: 'default' }}>Sí</span>
    </Tooltip>
  )
}

TagsIndicator.defaultProps = {
  tags: [],
}

export { TagsIndicator }
